import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import type { ServiceURLs } from '../app/services/[category]/types';
import { URLS } from './consts';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs) || '');
}

function normalizeStrings(strings: string[]): string {
  const lineCommentPattern = /\/\/.*((\r?\n)|$)/g;

  let result = strings.join(' ');

  if (result.includes('//')) {
    result = result.replace(lineCommentPattern, '');
  }

  return result.replace(/\s+/g, ' ').trim();
}

export function handleCLs(
  strings: TemplateStringsArray,
  ...expressions: ClassValue[]
): string {
  const classNamesList: string[] = strings.reduce(
    (previous, current, currentIndex) => {
      const expression = expressions[currentIndex];
      const resolvedClass = clsx(expression) || '';

      previous.push(current, resolvedClass);

      return previous;
    },
    [] as string[],
  );

  return normalizeStrings(classNamesList);
}

export function cls(
  strings: TemplateStringsArray,
  ...expressions: ClassValue[]
): string {
  return handleCLs(strings, ...expressions);
}

export function capitalizeFirstCharacter(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function capitalizeFirstCharactersForEachWord(
  text: string,
  separator = ' ',
  joiner = ' ',
) {
  return text
    .split(separator)
    .map(word => capitalizeFirstCharacter(word))
    .join(joiner);
}

export function formatForUrl(text: string): string {
  return text.toLowerCase().replace(/\s/g, '-');
}

export function formatForLabel(text: string): string {
  return capitalizeFirstCharactersForEachWord(
    text.toLowerCase().replaceAll('_', ' ').replaceAll('and', '&'),
  );
}

export function getServicePath(pathname: string): ServiceURLs | null {
  const validPaths = Object.values(URLS.SERVICES).filter(
    path => path !== URLS.SERVICES.ROOT,
  ) as ServiceURLs[];

  return validPaths.find(path => pathname.startsWith(path)) ?? null;
}
